<template lang="pug">
    v-autocomplete(
        @change="onChange()"
        :label="$t('Search_by_company_name')"
        :placeholder="$t('Search_by_company_name')"
        data-v-step='0'
        :items="getAllStocks"
        item-text="name"
        item-value="ticker"
        v-model="selectedStock"
        return-object
        dense
        solo
    )
        template(v-slot:selection="data")
            Ticker(:stockId="data.item.stock_id" :isClickable="false")
        template(v-slot:item="data")
            div(class="d-flex flex-column justify-content-center")
                Ticker(:stockId="data.item.stock_id" :isClickable="false")
                p {{data.item.name}}

</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import Ticker from "../../../components/Ticker.vue";

    export default {
        name: "stockSelector",
        props: ['parentStock', 'account'],
        components: {
            Ticker
        },
        data() {
            return {
                selectedStock: null,
            };
        },
        computed: {
            ...mapGetters([
                "getAllStocks",
                "getStock"
            ]),
            user_id() {
                return JSON.parse(localStorage.getItem('user')).user_id;
            }
        },
        methods: {
            ...mapActions([
                "setPushToStocksAction",
                "loadTxOrders",
                "loadTx",
                "loadTrades"
            ]),
            async init() {
                await this.loadTx(this.user_id);
                await this.loadTrades(this.user_id);
                await this.loadTxOrders(this.account.user_account_id);
            },
            async onChange() {
                await this.init();
                await this.setPushToStocksAction(this.selectedStock);
                const expandedStock = await this.getStock(this.selectedStock.company_id);
                this.$emit("setStock", expandedStock);
            },
        },
        watch: {
            parentStock(newStock) {
                if(!newStock) {
                    this.selectedStock = null
                }
            }
        }
    };
</script>

<style scoped>
    .selectOption {
        width: 100%;
        display: flex;
        justify-content: space-around;
    }
</style>
